import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { updateNavigationItem } from 'app/store/fuse/navigationSlice';
import { deploymentRegion, DEPLOYMENT_REGIONS } from 'app/constants';

export default function useShowCanadaOrders() {
  const navigate = useNavigate();
  const location = useLocation();

  const { selectedPharmacy } = useSelector((state) => state.pharmacySelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (deploymentRegion !== DEPLOYMENT_REGIONS.CA) return;
    if (!selectedPharmacy) return;

    const isPropelIntegrated = selectedPharmacy.integrations?.propel === true;

    dispatch(
      updateNavigationItem('orders-component', {
        display: !isPropelIntegrated,
      })
    );

    dispatch(updateNavigationItem('requests-component', { display: isPropelIntegrated }));

    if (isPropelIntegrated && location.pathname === '/orders') {
      navigate('/requests');
    }

    if (!isPropelIntegrated && location.pathname === '/requests') {
      navigate('/orders');
    }
  }, [selectedPharmacy, dispatch, location.pathname, navigate]);
}
